export default {
  /**
   * Tính giá
   */
  CalculatePrice: 1,

  /**
   * Bảo trì
   */
  ReBuild: 9,

  /**
   * Đánh lại số chứng từ
   */
  ReOrderRefNo: 3,

  /**
   * Ghi sổ bỏ ghi theo lô
   */
  PostBath: 4,

  /**
   * Khóa sổ
   */
  CloseBook: 5,

  /**
   * Thông báo sắp hết hạn license
   */
  WarningExpired: 8,

  /**
   * Chuyển đổi thành công
   */
  ConvertSuccess: 14,

  /**
   * bắt đầu chuyển đổi dữ liệu desktop - online
   */
  StartConvert: 15,
  /**
   * Chuyển đổi dữ liệu xong
   */
  EndConvert: 16,
  /**
   * Chuyển đổi bị lỗi
   */
  ConvertError: 17,
  /**
   * Đang tạo dữ liệu
   */
  CreatingData: 28,
  /**
   * Lỗi tạo dữ liệu
   */
  ErrorCreateData: 18,
  /**
   * Hoàn thành tạo dữ liệu
   */
  EndCreateData: 19,
  /**
   * Đổi tên dữ liệu
   */
  ChangeDatabaseName: 29,
  /**
   * Đang xóa dữ liệu
   */
  DeletingDatabase: 30,
  /**
   * Đã xóa dữ liệu
   */
  EndDeleteDatabase: 31,

  /**
   * Hoàn thành sao lưu
   */
  Backup: 20,
  /**
   * Hoàn thành phục hồi
   */
  Restore: 21,

  /**
   * Cảnh báo gần hết hạn - Dùng thử
   */
  WarningNearExpiredTrial: 22,
  /**
   * Cảnh báo mới hết hạn - Dùng thử
   */
  WarningExpiredTrial: 23,
  /**
   * Cảnh báo hết hạn quá - Dùng thử
   */
  WarningOverExpiredTrial: 24,
  /**
   * Cảnh báo gần hết hạn - Chính thức
   */
  WarningNearExpiredOffical: 25,
  /**
   * Cảnh báo mới hết hạn - Chính thức
   */
  WarningExpiredOffical: 26,
  /**
   * Cảnh báo hết hạn quá - Chính thức
   */
  WarningOverExpiredOffical: 27,

  /**
   * Khuyến mại
   */
  Promotion: 102,
  /**
   * Hệ thống
   */
  System: 101,

  /**
   * Sao lưu xong (Có thể lỗi hoặc thành công)
   */
  BackupDataCompleted: 32,

  /**
   * Khôi phục xong (Có thể lỗi hoặc thành công)
   */
  RestoreDataCompleted: 33,

  /**
   * tạo data mới từ data cũ
   */
  createDataFromOldDataComplete: 34,

  /**
   * Chia sẻ dữ liệu
   */
  Sharing: 34,

  /**
   * Bỏ Chia sẻ dữ liệu
   */
  Unsharing: 35,

  /**
   * Sao chép dữ liệu
   */
  CopyData: 103,
};
